import { IGetRequisicaoCompraDropDownUseCase } from "../../../presentation/useCases/read/get_requisicao_compra_drop_down_use_case";
import { RequisicaoCompraDropDown } from "../../models/requisicao_compra_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetRequisicaoCompraDropDownUseCase
 */

export class GetRequisicaoCompraDropDownUseCase implements IGetRequisicaoCompraDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getRequisicaoCompraDropDown(
    filtrarAprovados?: boolean,
  ): Promise<RequisicaoCompraDropDown[]> {
    return await this.repository.getRequisicaoCompraDropDown(
      filtrarAprovados ?? false,
    );
  }
}
